import React, { useState, useEffect } from "react";
import { buildApiUrl } from '../config';
import "./StockSales.css"; // Ensure styling matches other modules

const StockSales = () => {
  const [stockSales, setStockSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchStockSales();
  }, []);

  const fetchStockSales = async () => {
    try {
      const response = await fetch(buildApiUrl("api/stock/sales"));
      const data = await response.json();
      if (data.success) {
        setStockSales(data.data);
        setFilteredSales(data.data);
      } else {
        console.error("Error fetching stock sales:", data.error);
      }
    } catch (error) {
      console.error("Error fetching stock sales:", error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    filterSales(value, startDate, endDate);
  };

  const handleFilterByDate = () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    
    const filteredData = stockSales.filter((sale) => {
      const saleDate = new Date(sale.SaleDate);
      return saleDate >= start && saleDate <= end;
    });

    if (filteredData.length === 0) {
      alert("No records found for the selected date range.");
    }

    setFilteredSales(filteredData);
  };

  const filterSales = (searchValue, start, end) => {
    let result = stockSales;

    if (searchValue) {
      result = result.filter((sale) =>
        sale.VehicleNumber.toLowerCase().includes(searchValue)
      );
    }

    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      result = result.filter((sale) => {
        const saleDate = new Date(sale.SaleDate);
        return saleDate >= startDate && saleDate <= endDate;
      });
    }

    setFilteredSales(result);
  };

  return (
    <div className="stock-sales-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
        <h1 style={{ margin: 0 }}>Stock Sales</h1>
        <button
          onClick={() => {
            try {
              if (!filteredSales || filteredSales.length === 0) {
                alert('No data to export');
                return;
              }
              const headers = ['Date','Stock Type','Brand','Oil Type / Filter No','Customer Name','Vehicle No','Vehicle Type','Quantity','Amount'];
              const rows = filteredSales.map(sale => [
                sale.TransactionDate ? new Date(sale.TransactionDate).toLocaleDateString('en-GB') : '-',
                sale.StockType ?? '-',
                sale.Brand ?? '-',
                sale.Type ?? '-',
                sale.CustomerName ?? '-',
                sale.VehicleNumber ?? '-',
                sale.VehicleType ?? '-',
                sale.Quantity !== undefined ? String(Math.abs(sale.Quantity)) + (sale.StockType === 'Oil' ? ' Litres' : '') : '-',
                sale.Amount ?? '-'
              ]);
              const csv = [headers, ...rows]
                .map(row => row.map(cell => {
                  const val = cell === null || cell === undefined ? '' : String(cell);
                  const escaped = val.replace(/"/g, '""');
                  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
                }).join(',')).join('\n');
              const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Stock_Sales_${new Date().toISOString().split('T')[0]}.csv`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            } catch (e) {
              console.error('Export failed', e);
              alert('Failed to export CSV');
            }
          }}
          style={{
            background: 'none',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '18px',
            color: '#217346',
            padding: '6px 10px'
          }}
          title="Export current table to CSV"
        >
          📊
        </button>
      </div>

   


      {/* 🔹 Sales Table */}
      <table className="stock-sales-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Stock Type</th>
            <th>Brand</th>
            <th>Oil Type / Filter No</th>
            <th>Customer Name</th>  {/* ✅ New Column */}
            <th>Vehicle No</th>
            <th>Vehicle Type</th>
            <th>Quantity</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {filteredSales.length > 0 ? (
            filteredSales.map((sale, index) => (
              <tr key={index}>

<td>
  {sale.TransactionDate 
    ? new Date(sale.TransactionDate).toISOString().split("T")[0].split("-").reverse().join("/") 
    : "N/A"}
</td>

                <td>{sale.StockType}</td>
                <td>{sale.Brand}</td>
                <td>{sale.Type}</td>
                <td>{sale.CustomerName || "N/A"}</td>  {/* ✅ Display Customer Name */}
                <td>{sale.VehicleNumber}</td>
                <td>{sale.VehicleType}</td>
                <td>{Math.abs(sale.Quantity)} {sale.StockType === "Oil" ? "Litres" : ""}</td>
                <td>{sale.Amount}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">No sales records found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StockSales;
